<template>
  <span class="m-billingFrequency" :data-billing-period="billingFrequency">
    {{ billingStartDateMessage }}
    {{ billingFrequencyMessage }}
  </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    items: (state) => state.cart.items,
    currency: (state) => state.cart.currency,
    totalAmount: state => state.cart.totalAmount,
    hasPromotion () {
      if (this.items !== undefined && this.items.length > 0) {
        if (this.items[0].base_price !== this.items[0].price) {
          return true
        }
      }
      return false
    },
    tllRemainingDays: state => state.cart.items[0] ? state.cart.items[0].tll_remaining_days : 0,
    // Show "From (date) pay (price)" message for sub products:
    //  - if the cart item does not have a promotion AND
    //  - if the cart item's total amount is not 0.00 AND
    //  - if the user has a valid TLL that has not expired yet (tllRemainingDays is greater than 0)
    billingStartDateMessage () {
      const shouldDisplayBillingStartDate = !!(!this.hasPromotion &&
          this.totalAmount !== '0.00' &&
          this.tllRemainingDays)
      if (shouldDisplayBillingStartDate) {
        const splitSubDate = this.items[0].subscription_start_date.split(' ')
        const subscriptionStartDate = splitSubDate[0] + ' ' + splitSubDate[1]
        const finalPrice = this.currency + ' ' + this.totalAmount
        return 'From ' + subscriptionStartDate + ' pay ' + finalPrice
      } else {
        return null
      }
    },
    // Show 'per month', 'annually', 'every x months' message:
    //  - if there are items in the cart AND
    //  - if there are no coupons/promotions applied
    billingFrequencyMessage () {
      const items = this.items
      if (items && !this.hasPromotion) {
        if (items[0].product_type.subscription) {
          switch (items[0].product_type.billing_period) {
            case 1:
              return 'per month'
            case 12:
              return 'annually'
            default:
              return 'every ' + items[0].product_type.billing_period + ' months'
          }
        }
      } else {
        return null
      }
    }
  }),
  data () {
    return {
      billingFrequency: ''
    }
  },
  created () {
    this.billingFrequency = this.items[0].product_type.billing_period
  }
}
</script>

<style lang="scss" scoped>
.m-billingFrequency {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// BillingFrequency.vue?25bfe791